/**
 * Request the user's current position (browser Geolocation API).
 * @returns {Promise<{ lat: number, lng: number, accuracy?: number }>}
 */
export function getCurrentPosition(options = {}) {
  return new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(new Error('Geolocation is not supported on this device'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        });
      },
      (err) => {
        const msg =
          err.code === 1 ? 'Location permission denied'
          : err.code === 2 ? 'Location unavailable'
          : err.code === 3 ? 'Location request timed out'
          : err.message || 'Failed to get location';
        reject(new Error(msg));
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 60000,
        ...options,
      },
    );
  });
}
